import { render, staticRenderFns } from "./GetCustomerIncome.vue?vue&type=template&id=bce8f584&scoped=true&"
import script from "./GetCustomerIncome.vue?vue&type=script&lang=js&"
export * from "./GetCustomerIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce8f584",
  null
  
)

export default component.exports